import React from 'react';
import { Typography, Box } from '@mui/material';
import NetworkHealthCard from './NetworkHealthCard';
import { useTranslation } from 'react-i18next';

interface NetworkStatusProps {
  status: string;
}

const NetworkStatus: React.FC<NetworkStatusProps> = ({ status }) => {
  const { t } = useTranslation();
  return (
    <NetworkHealthCard>
      <Typography variant="h6" gutterBottom>
        {t('network_status')}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
          color:
            status === 'Connected'
              ? '#4CAF50'
              : status === 'Good'
              ? '#FFC107'
              : '#F44336',
          fontSize: '1.5rem',
          fontWeight: 'bold',
        }}
      >
        <span style={{ fontSize: '2rem' }}>●</span> {status}
      </Box>
    </NetworkHealthCard>
  );
};

export default NetworkStatus;
